import React from 'react';

function MobileApp() {
  return (
    <section className="section section-dark" id="mobile-app">
      <div className="container">
        <div className="app-section-grid">
          <div className="app-content fade-in">
            <div className="section-badge">Mobile App</div>
            <h2 className="section-title" style={{ textAlign: 'left' }}>
              Your Workforce in<br />Your Pocket
            </h2>
            <p className="section-subtitle" style={{ textAlign: 'left', maxWidth: 480 }}>
              Manage shifts, track attendance, request leave, and stay notified — all from your phone.
              The 9works mobile app brings the full power of our platform right to your fingertips.
            </p>

            <div className="app-features-list">
              <div className="app-feature-item">
                <div className="app-feature-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
                  </svg>
                </div>
                <span>Real-time shift notifications</span>
              </div>
              <div className="app-feature-item">
                <div className="app-feature-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
                  </svg>
                </div>
                <span>One-tap clock in / clock out</span>
              </div>
              <div className="app-feature-item">
                <div className="app-feature-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
                  </svg>
                </div>
                <span>Leave requests on the go</span>
              </div>
              <div className="app-feature-item">
                <div className="app-feature-icon">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
                  </svg>
                </div>
                <span>View schedules & payslips</span>
              </div>
            </div>

            <div className="app-store-buttons">
              <a href="#" className="app-store-btn" onClick={(e) => e.preventDefault()}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                </svg>
                <div>
                  <span className="app-store-label">Coming Soon on</span>
                  <span className="app-store-name">App Store</span>
                </div>
              </a>
              <a href="#" className="app-store-btn" onClick={(e) => e.preventDefault()}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.199l2.302 2.302a1 1 0 0 1 0 1.38l-2.302 2.302L15.396 13l2.302-2.492zM5.864 2.658L16.8 8.99l-2.302 2.302-8.635-8.635z"/>
                </svg>
                <div>
                  <span className="app-store-label">Coming Soon on</span>
                  <span className="app-store-name">Google Play</span>
                </div>
              </a>
            </div>

            <div className="app-coming-soon-badge">
              <span className="hero-badge-dot"></span>
              Launching April 2026
            </div>
          </div>

          <div className="app-visual fade-in fade-in-delay-2">
            <div className="phone-mockup">
              <div className="phone-frame">
                <div className="phone-notch"></div>
                <div className="phone-screen">
                  <div className="phone-status-bar">
                    <span>9:41</span>
                    <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z"/></svg>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><rect x="17" y="4" width="4" height="16" rx="1"/><rect x="11" y="8" width="4" height="12" rx="1"/><rect x="5" y="12" width="4" height="8" rx="1"/></svg>
                    </div>
                  </div>
                  <div className="phone-header">
                    <div className="phone-greeting">Good Morning!</div>
                    <div className="phone-name">Your Next Shift</div>
                  </div>
                  <div className="phone-shift-card">
                    <div className="phone-shift-time">09:00 AM — 05:00 PM</div>
                    <div className="phone-shift-type">Morning Shift</div>
                    <div className="phone-shift-dept">Engineering Dept</div>
                    <div className="phone-clock-btn">Clock In</div>
                  </div>
                  <div className="phone-quick-actions">
                    <div className="phone-quick-item">
                      <div className="phone-quick-icon" style={{ background: 'rgba(84,184,72,0.15)' }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#54b848" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/></svg>
                      </div>
                      <span>Schedule</span>
                    </div>
                    <div className="phone-quick-item">
                      <div className="phone-quick-icon" style={{ background: 'rgba(59,130,246,0.15)' }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                      </div>
                      <span>Leave</span>
                    </div>
                    <div className="phone-quick-item">
                      <div className="phone-quick-icon" style={{ background: 'rgba(245,158,11,0.15)' }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
                      </div>
                      <span>Alerts</span>
                    </div>
                    <div className="phone-quick-item">
                      <div className="phone-quick-icon" style={{ background: 'rgba(168,85,247,0.15)' }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#a855f7" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
                      </div>
                      <span>Payslip</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MobileApp;
